import { Box } from "@mui/material";
import React from "react";
import '../../App.css';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { useBackground } from "../../hooks/useBackgroundManager.jsx";

function BackgroundManager() {
    const { backgrounds, setBackgrounds } = useBackground();

    return (
        <TransitionGroup component={null}>
            {backgrounds.map((background) => (
                <CSSTransition
                    key={background.id}
                    timeout={1000}
                    classNames="fade"
                    onExited={() => {
                        setBackgrounds(prevBackgrounds => prevBackgrounds.filter(bg => bg.id !== background.id));
                    }}
                >
                    {background.src.endsWith(".mp4") ? (
                        <video
                            playsInline
                            loop
                            muted
                            autoPlay
                            className="background"
                            style={{
                                pointerEvents: 'none',
                                zIndex: "-50",
                                position: "absolute",
                                top: 0,
                                left: 0,
                                objectFit: "cover",
                                height: "100%",
                                width: "100%",
                                willChange: "opacity, transform",
                            }}
                            src={background.src}
                        />
                    ) : (
                        <Box
                            key={background.id}
                            component="img"
                            className="background"
                            src={background.src}
                            alt="Project Background"
                            sx={{
                                position: "absolute", top: 0, left: 0, objectFit: "cover", height: "100%", width: "100%", willChange: "opacity, transform"
                            }}
                        />
                    )}
                </CSSTransition>
            ))}
        </TransitionGroup>
    );
}

export default BackgroundManager;